<template>
    <v-layout class="m-list-business-types-logo">
        <div v-for="logo in items" class="business-type-logo" tabindex="1">
            <img :src="logo.src" :alt="logo.alt" height="25px" @click="showBusinessTypeInfo(logo)" tabindex="0" @keyup.enter="showBusinessTypeInfo(logo)"/>
        </div>
    </v-layout>


</template>

<script>
    import dialogs from '@mixins/includes/_dialogs';

    let name = 'm-list-business-types-logo';
    export default {
        name: name,
        props: {
            name: {
                type: String,
                default: name
            }
        },
        mixins: [dialogs],
        data() {
            return {
                items: [
                    {
                        type: 'roofers',
                        src: require('@/assets/images/logos/logo-dachdecker.jpg'),
                        images: [
                            {
                                "src": "https://bgbgb-cdn.portsol19.de/images/ordner/ordner-dachdecker.jpg"
                            }
                        ]
                    },
                    {
                        type: 'carpenters',
                        src:  require('@/assets/images/logos/logo-zimmerer.jpg'),
                        images: [
                            {
                                "src": "https://bgbgb-cdn.portsol19.de/images/ordner/ordner-zimmerer1.jpg"
                            },
                            {
                                "src": "https://bgbgb-cdn.portsol19.de/images/ordner/ordner-zimmerer2.jpg"
                            },
                            {
                                "src": "https://bgbgb-cdn.portsol19.de/images/ordner/ordner-zimmerer3.jpg"
                            }
                        ]
                    }
                ]
            }
        },
        methods: {
            showBusinessTypeInfo(item) {
                this.openDialog({
                    type: 'businessTypeInfo',
                    options: {
                        type: item.type,
                        images: item.images
                    }
                });
            }
        }
    }
</script>
<style lang="scss" scoped>
  .container .layout .m-list-business-types-logo {
      margin-left:0;


  }
  .business-type-logo {
    cursor: pointer;
      padding: 0 10px;
  }
</style>
